import EsEnum from '@/utils/EsEnum'

// UIAccessPriorities
const LoginStatus = new EsEnum(
    [
        {
            name: 'offline',
            value: '用户离线！'
        },
        {
            name: 'expired',
            value: '长时间未操作,请重新登录！'
        },
        {
            name: 'offlines',
            value: '账号在别的地方登录！'
        }
    ])
const MobileSystemType = new EsEnum(
    [
        {
            name: 'IOS',
            value: '1'
        },
        {
            name: 'Android',
            value: '2'
        }
    ])
const PaymentWay= new EsEnum(
    [
        {
            name: '免费',
            value: '0'
        },
        {
            name: '微信',
            value: '1'
        },
        {
            name: '支付宝',
            value: '2'
        },
        {
            name: '其它',
            value: '3'
        }
    ])
    const SexsEnum = new EsEnum([
        // { name: '未知', value: 0 },
        {
          name: '男',
          value: 1
        },
        {
          name: '女',
          value: 2
        }
      ])
      const PaymentStatus = new EsEnum([
        // { name: '未知', value: 0 },
        {
          name: '支付中',
          value: 0
        },
        {
          name: '完成支付',
          value: 1
        }
      ])
      const CloudImagePACSTypes = new EsEnum([
        {
          name: 'ELPACS',
          value: 0
        },
        {
          name: 'WPACS',
          value: 1
        }
      ])
export default {
    LoginStatus,MobileSystemType,PaymentWay,SexsEnum,PaymentStatus,CloudImagePACSTypes
}